import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#F0C300",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "m27.258 20.227-5.484-6.054a.445.445 0 0 0-.614 0l-5.32 5.85c-.165.163-.451.041-.41-.205l.696-3.109c.04-.122 0-.245-.082-.368l-5.28-6.055a.58.58 0 0 0-.9 0L2.7 18.55V4.273c0-.328.246-.573.573-.573h23.452c.286.04.532.286.532.573zM26.726 1l-23.452.041A3.283 3.283 0 0 0 0 4.314v20.413C0 26.527 1.473 28 3.274 28h23.452A3.283 3.283 0 0 0 30 24.727V4.273C30 2.473 28.527 1 26.726 1" }),
      _createElementVNode("path", { d: "M22 7a2 2 0 1 1 0 4 2 2 0 0 1 0-4" })
    ], -1)
  ]))]))
}
export default { render: render }